import React from 'react';
import { useLocation, useOutletContext, Link } from 'react-router-dom';
import { Row, Col, Container, Placeholder, Card } from 'react-bootstrap';

const DetailedProduct = () => {
  const location = useLocation();
  const { l } = useOutletContext();
  const { product } = location.state || {};

  if (!product) {
    return (
      <Container className="py-5">
        <h1 className="fw-bold mb-3">{l('Produkt saknas', 'Product not found')}</h1>
        <Link to="/products" style={{ textDecoration: 'none', color: 'var(--newRed2)' }}>
          <i className="fa fa-arrow-left" />&nbsp;&nbsp;{l('Till produkter', 'Back to products')}
        </Link>
      </Container>
    );
  }

  const getSheetName = (sheet) => {
    if(!l(sheet.titleSv, sheet.titleEn)) return sheet.name.replace(/\.pdf$/i, '');
    return l(sheet.titleSv, sheet.titleEn);
  }

  return (
    <>


      <Container className='my-lg-5 my-3'>
        <div className="mb-5">
          <Row className="align-items-center">
            {/* Arrow link first on small/medium, second on large */}
            <Col xs={12} lg="auto" className="order-1 order-lg-2 text-lg-end">
              <Link
                to="/products"
                className="mx-3"
                style={{ textDecoration: 'none', color: 'var(--newRed2)' }}
              >
                <i className="fa fa-arrow-left"></i>&nbsp;&nbsp;
                {l('Produkter', 'Products')}
              </Link>
            </Col>

            {/* Product name second on small/medium, first on large */}
            <Col xs={12} lg={6} className="order-2 order-lg-1 mt-lg-0 mt-3">
              <h1 className="mb-3 fw-bold text-lg-start text-center">{product.name}</h1>
            </Col>
          </Row>

          {/* Main content: image + description */}
          <Row className="mt-lg-4 mt-0 g-4 align-items-start">

            {product.imageSrc?.file &&
              <Col xs={12} md={5} lg={4} className="d-flex justify-content-center justify-content-md-start">
                <img
                  className="img-fluid"
                  style={{ maxHeight: 260, objectFit: 'contain' }}
                  src={product.imageSrc.file}
                  alt={product.name}
                />
              </Col>
            }


            <Col xs={12} md={7} lg={8} >
              <p className="lead mb-0 productParagraph">{l(product.contentSwe, product.contentEng)}</p>
            </Col>
          </Row>

          {/* Data sheets box */}
          <Row className="mt-4">
            <Col xs={12} md={8} lg={6} xl={5}>
              <div className="p-3 border rounded-3">
                <h3 className="mb-4">{l('Datablad', 'Data sheets')}</h3>
                {product.safetySheets && product.safetySheets.length > 0 ? (
                  product.safetySheets.map((safetySheet, index) => (
                    <div key={index} className="mb-3">
                      <Link to={safetySheet.file} style={{ textDecoration: 'none' }} reloadDocument>
                        <p className="mb-0">{getSheetName(safetySheet)}</p>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="mb-0">{l('Inga datablad tillgängliga', 'No data sheets available')}</p>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default DetailedProduct;
